import { combineReducers } from '@reduxjs/toolkit';
import { configurationReducer, initialState as configurationInitialState } from '../configuration/store';
import { overviewSlice } from '../overview/store/slice';
import { commonSlice } from './common';
import { rebalanceSlice } from './rebalance';
import { PortfolioState } from './types';

export const portfolioReducer = combineReducers<PortfolioState>({
  overview: overviewSlice.reducer,
  configuration: configurationReducer,
  common: commonSlice.reducer,
  rebalance: rebalanceSlice.reducer,
});

export const initialState: PortfolioState = {
  overview: overviewSlice.getInitialState(),
  configuration: configurationInitialState,
  common: commonSlice.getInitialState(),
  rebalance: rebalanceSlice.getInitialState(),
};
